import { AuthCAS } from '@app/types';
import { createSlice } from '@reduxjs/toolkit'

export type AvailableCASItem = {
  assetRepository: string;
  amcName: string;
  amcCode: string;
  folioNo: string;
  schemeCode: string;
  schemeName: string;
  isinNo: string;
  schemeType: string;
  totalAvailableUnits: number;
  fetchedOn: any;
  is_pledged: boolean;
  is_pledged_confirmed: boolean;
  pledgedUnits: any;
  pledgedOn: any;
  pledgeReferenceNo: any;
};

export interface AvailableCASMap {
  [key: string]: AvailableCASItem;
}

export interface MinimumEligibleLimit {
  amount: number
  nonEligibleDisplayReason: any
  isEligible: any
}

interface ApplicationState {
  authCAS: AuthCAS | null,
  availableCAS: AvailableCASMap | null,
  minimumEligibleLimit: MinimumEligibleLimit | null,
  shareLinkStepId: string | null
}

const initialState : ApplicationState = {
    authCAS: null,
    availableCAS: null,
    minimumEligibleLimit: null,
    shareLinkStepId: null
};

export const applicationSlice = createSlice({
  name: 'application',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setAuthCAS: (state, action) => {
      state.authCAS = action.payload;
    },
    setAvailableCAS: (state, action) => {
      state.availableCAS = action.payload;
    },
    setMinimumEligibleLimit: (state, action) => {
      state.minimumEligibleLimit = action.payload;
    },
    setShareLinkStepId: (state, action) => {
      state.shareLinkStepId = action.payload;
    }
  },
})

export const {  setAuthCAS, setAvailableCAS, setMinimumEligibleLimit, setShareLinkStepId} = applicationSlice.actions

export default applicationSlice.reducer